import gsap from "gsap";

(() => {
	const pageTitle = document.querySelector(".attractions-header__title");
	const pageSubtitle = document.querySelector(
		".attractions-header__subtitle"
	);

	const attractionItems = document.querySelectorAll(".attractions-item");

	const initAnimation = gsap.timeline();

	initAnimation.from(pageTitle, {
		duration: 1,
		ease: "power2.out",
		y: "100px",
		opacity: "0",
	});

	initAnimation.from(
		pageSubtitle,
		{
			duration: 1,
			ease: "power2.out",
			y: "100px",
			opacity: "0",
		},
		"-=.7"
	);

	gsap.from(attractionItems, {
		duration: 2,
		opacity: "0",
		ease: "power3.out",
		stagger: 0.1,
	});
})();
